var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-1.5","x2":"22.8763","y2":"-1.5","transform":"matrix(0.714221 0.69992 -0.714221 0.69992 0 3)","stroke":"#000000","strokeWidth":"3","key":0}),React.createElement("line",{"y1":"-1.5","x2":"22.8763","y2":"-1.5","transform":"matrix(-0.714717 0.699413 0.714717 0.699413 32.7031 3)","stroke":"#000000","strokeWidth":"3","key":1})]);
}

Arrow.defaultProps = {"width":"33","height":"20","viewBox":"0 0 33 20","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
